/* Cart drawer sync — fixes the "Loading… / ₹0 / disabled checkout" stale drawer.
   Any /cart/add (from the theme OR the Breeze app) re-renders Dawn's cart-drawer
   + cart-icon-bubble sections, syncs them into the DOM, and opens the drawer with
   a working total and an enabled Checkout button. Also catches XHR-based adds. */
(function () {
  var refreshing = false;

  function refresh(openAfter) {
    if (refreshing) return;
    refreshing = true;
    fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && data['cart-drawer']) {
            var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
            var newInner = doc.querySelector('cart-drawer .drawer__inner') || doc.querySelector('.drawer__inner');
            var curInner = drawer.querySelector('.drawer__inner');
            if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
            var emptyNode = doc.querySelector('cart-drawer.is-empty') || doc.querySelector('.cart-drawer.is-empty');
            drawer.classList.toggle('is-empty', !!emptyNode);
          }
          if (data['cart-icon-bubble']) {
            var host = document.getElementById('cart-icon-bubble');
            if (host) {
              var bd = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
              var nb = bd.querySelector('#cart-icon-bubble');
              if (nb) host.innerHTML = nb.innerHTML;
            }
          }
          if (openAfter && drawer && !drawer.classList.contains('is-empty')) {
            if (typeof drawer.open === 'function') {
              drawer.open(document.querySelector('#cart-icon-bubble'));
            } else {
              drawer.classList.add('active', 'animate');
              document.body.classList.add('overflow-hidden');
            }
          }
        } catch (e) {}
      })
      .catch(function () {})
      .then(function () { refreshing = false; });
  }

  function isCartWrite(u) { return typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u); }
  function isAdd(u) { return typeof u === 'string' && /\/cart\/add/.test(u); }

  // fetch()
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var u = (arguments[0] && arguments[0].url) || arguments[0] || '';
      var p = origFetch.apply(this, arguments);
      try {
        if (isCartWrite(u)) {
          var add = isAdd(u);
          p.then(function (res) { if (res && res.ok) setTimeout(function () { refresh(add); }, 180); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  // XMLHttpRequest (Breeze / legacy paths)
  var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cartWrite = isCartWrite(u); this.__cartAdd = isAdd(u); return oOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (x.__cartWrite) {
      x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) setTimeout(function () { refresh(x.__cartAdd); }, 180); });
    }
    return oSend.apply(this, arguments);
  };
})();
